import * as errorMessages from '../../../constants/errorMessages.js';
//import * as editChecks from '../../../constants/injurySummaryEditConstants.js';
import * as caseDataConstants from '../../../constants/caseDataConstants';
import CASE_DATA_FORM_FIELD_NAMES from '../../../constants/caseDataFormFieldNames.js';

export default function confirmFormIsValid(caseDataForm, caseData, requiredFields, activeFields, caseDatas = []) {
  let formIsValid = true;
  let errors = {};
  let softErrors = {};
  requiredFields.map(questionPart => {
    let fieldName = questionPart.questionPartName;
    let label = questionPart.questionPartLabel;
    //if field is empty, set the empty value error message
    if (!caseData[fieldName] && caseData[fieldName] !== 0) {
      formIsValid = false;
      if (activeFields.indexOf(fieldName) !== -1) {
        errors[fieldName] = label.slice(0, label.indexOf("(")) + errorMessages.ERROR_NEEDS_VALUE;
      }
    }
  });

  /**
   * Date related validations
   *
   * Date of incident = must be in the same calendar year as the year of filing or one year prior
   * Date of death and date of incident = must be after date of hire
   * Date of birth = must be >1 year old; cannot be in the same calendar year as year of filing
   * All dates = cannot be in the future; cannot be >100 years ago
   *
   * Fields
   *   injuryDate
   *   dateOfDeath
   *   dateOfBirth
   *   employeeHiredDate
   */

  const dateFields = ['injuryDate', 'dateOfDeath', 'dateOfBirth', 'employeeHiredDate'];

  /**
   * Special charachter related validations
   *
   * Add fiedls that doesn't accept spcecial characher to the following array.
   */
  const noneSpecialCharachterFields = ['caseNumber'];

  // Define a regular expression that allows only letters, numbers, and underscores
  const noneSpecialCharachterRegex = /^[A-Za-z0-9_-]+$/;

  /**
   * Alphanumeric only validation.
   *
   * Add fiedls that doesn't accept anything otherthan Alphanumeric charachters to the following array.
   */
  const alphanumericOnlyFields = ['jobTitle'];

  // Define a regular expression that allows Alphanumerics.
  const alphanumericOnlyRegex = /^[A-Za-z0-9_ -]+$/;

  // console.log(caseData);

  caseDataForm.formQuestions.forEach(question => {
    question.questionParts.map(questionPart => {
      let fieldName = questionPart.questionPartName;
      // Can use label if we want to.
      // let label = questionPart.questionPartLabel;
      // If the field is a date field and if it is active and it is not empty.
      // then validate the date and show error if it is an invalid date range.
      // Valid date range is Today - Today minus 100 years
      if (dateFields.includes(fieldName) && caseData[fieldName]) {
        let currentDate = new Date();
        // @Todo - This will have a problem on Jan 1.
        let valueDate = new Date(caseData[fieldName]);
        // Adding the T00:00:00 to the date string to
        // address the issue with new Date() converting the string to a date
        // in UTC but getFullYear will pull the year from the current timezone
        // So years would be different in the edge conditions. When date string
        // is 1/1/2023, the yearOfValue returns as 2022 because of this issue.
        let yearOfValue = (new Date(caseData[fieldName].trim() + "T00:00:00")).getFullYear();
        let currentYear = currentDate.getFullYear();
        if (activeFields.indexOf(fieldName) !== -1) {
          if (valueDate > currentDate) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_NO_FUTURE_DATES; 
          }
          // No dates can be older than 100 years.
          if (yearOfValue < (currentYear - 100)) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_INVALID_YEAR;
          }
          // Injury date has to be in the current year or previous year.
          if (fieldName == 'injuryDate' || fieldName == 'dateOfDeath') {
            if (yearOfValue != currentYear && yearOfValue != (currentYear - 1)) {
              formIsValid = false;
              errors[fieldName] = errorMessages.ERROR_CASE_DATA_INJURY_YEAR_RANGE;
            }
            // If employee hire date is not empty and it is active.
            if (caseData['employeeHiredDate'] && activeFields.indexOf('employeeHiredDate') !== -1) {
              if (valueDate < (new Date(caseData['employeeHiredDate']))) {
                formIsValid = false;
                errors[fieldName] = errorMessages.ERROR_CASE_DATA_HIRE_DATE_RELATIONSHIP;
              }
            }
          }
          // Date of Death must be after Date of Injury.
          if (fieldName == 'dateOfDeath') {
            // If injuryDate is not empty and it is active.
            if (caseData['injuryDate'] && activeFields.indexOf('injuryDate') !== -1) {
              if (valueDate < (new Date(caseData['injuryDate']))) {
                formIsValid = false;
                errors[fieldName] = errorMessages.ERROR_DATE_OF_DEATH_INCIDENT_DATE_RELATIONSHIP;
              }
            }
          }
          // DOB cannot be in the current year. Technically why not <10 years.
          if (fieldName == 'dateOfBirth') {
            if (yearOfValue == currentYear) {
              formIsValid = false;
              errors[fieldName] = errorMessages.ERROR_DOB_INVALID_YEAR_RANGE; 
            }
          }
          // Hired date must be after DOB
          if (fieldName == 'employeeHiredDate') {
            if (caseData['dateOfBirth'] && activeFields.indexOf('dateOfBirth') !== -1) {
              if (valueDate < (new Date(caseData['dateOfBirth']))) {
                formIsValid = false;
                errors[fieldName] = errorMessages.ERROR_HIRED_DATE_INVALID_RANGE;
              }
            }
          }
        }
      }
      if (fieldName == 'dateOfDeath') {
        if (caseData['mostSeriousOutcome'] == caseDataConstants.MOST_SERIOUS_OUTCOME_DEATH) {
          if (caseData[fieldName] == '') {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_DATE_OF_DEATH_REQUIRED;
          }
        }
      }
      if (fieldName == 'awayFromWork' || fieldName == 'jobTransferRestriction') {
        if (typeof(caseData[fieldName]) !== 'undefined' && caseData[fieldName] != '') {
          if (!isIntegerValue(caseData[fieldName])) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_IS_NOT_A_NUMBER;
          }
          else if (caseData[fieldName] > 730 || caseData[fieldName] < 0) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_DAYS_LONGER_THAN_YEAR;
          }
          else if (caseData['mostSeriousOutcome'] == caseDataConstants.DAYS_AWAY_FROM_WORK
            && fieldName == 'awayFromWork' && caseData[fieldName] == 0) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_DAFW_REQUIRED;
          }
          else if (caseData['mostSeriousOutcome'] == caseDataConstants.JOB_TRANSFER_OR_RESTRICTION
            && fieldName == 'jobTransferRestriction' && caseData[fieldName] == 0) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_CASE_DATA_DJTR_REQUIRED;
          }
        }
      }
      // Validate special charachter.
      if (noneSpecialCharachterFields.includes(fieldName) && caseData[fieldName]) {
        if (!noneSpecialCharachterRegex.test(caseData[fieldName])) {
          formIsValid = false;
          errors[fieldName] = CASE_DATA_FORM_FIELD_NAMES[fieldName] + errorMessages.ERROR_INVALID_CHARACHTER;
        }
      }
      // Validate Alphanumeric only.
      if (alphanumericOnlyFields.includes(fieldName) && caseData[fieldName]) {
        if (!alphanumericOnlyRegex.test(caseData[fieldName])) {
          formIsValid = false;
          errors[fieldName] = CASE_DATA_FORM_FIELD_NAMES[fieldName] + errorMessages.ERROR_ALPHANUMERIC_ONLY;
        }
      }
      if (fieldName == 'caseNumber') {
        if (caseDatas.length > 0) {
          // Prevent Duplicate case numbers
          let repeatedCaseNumber = caseDatas.filter(singleCase => {
            return (
              singleCase.case_number.toUpperCase() === caseData.caseNumber.toUpperCase() &&
              singleCase.id !== caseData.id // Exclude the currently edited case by ID
            );
          })[0];
          if (repeatedCaseNumber) {
            formIsValid = false;
            errors[fieldName] = errorMessages.ERROR_REPEATED_CASE_NUMBER;
          }
        }
      }

    });
  });


/*   if (caseData.awayFromWork) {
    let message = checkForAlpha(caseData.awayFromWork);
    let fieldName = questionPart.questionPartName;
    let label = questionPart.questionPartLabel;
    if (message === 'failed: alphabetic') {
      formIsValid = false;
      errors[fieldName] = label.slice(0, label.indexOf("(")) + errorMessages.ERROR_CASE_DATA_ALPHA;
    }
  }

  if (caseData.jobTransferRestriction) {
    let message = checkForAlpha(caseData.jobTransferRestriction);
    let fieldName = questionPart.questionPartName;
    let label = questionPart.questionPartLabel;
    if (message === 'failed: alphabetic') {
      formIsValid = false;
      errors[fieldName] = label.slice(0, label.indexOf("(")) + errorMessages.ERROR_CASE_DATA_ALPHA;
    }
  } */

  return {formIsValid, errors, softErrors};
}

function isIntegerValue(str) {
  return /^\+?(0|[1-9]\d*)$/.test(str);
}

/* function checkForAlpha(field) {
  let message = '';
  if (!editChecks.REG_EX_NUMERIC.test(field)) {
    message = 'failed: alphabetic';
  }
  return message;
} */



/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDataEditChecks.js
 **/